import React, { useEffect, useState } from "react";
import { Modal, Form, Input, DatePicker, Select } from "antd";
// import { UseFetchListEnum } from "../../../../hooks/useFetchEnums";
// import { ENUM_TYPE } from "../../../../data/constant";

function ReportModal({ form, open, onOk, onCancel, confirmLoading }) {
    // const [reportOptions, setReportOptions] = useState([]);
    // const { mutateAsync: fetchReportOptions } = UseFetchListEnum();
    // useEffect(() => {
    //     listReportOptions()
    // }, [form, open]);
    // const listReportOptions = async () => {
    //     const result = await fetchReportOptions({ enumType: [ENUM_TYPE.report_output_type] });
    //     setReportOptions(result);
    // }
    return (
        <Modal
            title="แจ้งปัญหา (Output)"
            open={open}
            onOk={onOk}
            onCancel={onCancel}
            confirmLoading={confirmLoading}
            okText="ยืนยัน"
            cancelText="ยกเลิก"
        >
            <Form form={form}>
                {/* <Form.Item name="reportOptions" label="ตัวเลือก">
                    <Select
                        placeholder="กรุณาเลือก"
                        options={reportOptions}
                    />
                </Form.Item> */}
                <Form.Item name="reportRemark" label="เหตุผล">
                    <Input.TextArea placeholder="กรุณาระบุเหตุผล" rows={6} />
                </Form.Item>
                
            </Form>
        </Modal>
    );
}

export default ReportModal;